import Registration from '../views/Registration.vue';
import Registration1 from '../views/sections/Page1.vue';
import Registration2 from '../views/sections/Page2.vue';
import Registration3 from '../views/sections/Page3.vue';
import Registration4 from '../views/sections/Page4.vue';
import Registration5 from '../views/sections/Page5.vue';
import Registration6 from '../views/sections/Page6.vue';
import RegistrationBuilding from '../views/sections/Building.vue';
import RegistrationBuildingComplete from '../views/sections/BuildingComplete.vue';

export default [
  {
    path: '',
    name: 'Registration',
    component: Registration,
    title: 'TalentSensus',
    redirect: {
      name: 'registration1'
    },
    children: [
      {
        path: 'personal',
        name: 'registration1',
        component: Registration1,
        title: 'Company Registration',
        meta: {
          currentProgress: 0,
          label: "1. Basic Details"
        }
      },
      {
        path: 'company',
        name: 'registration2',
        component: Registration2,
        title: 'Company Registration',
        meta: {
          currentProgress: 20,
          label: "2. Company Details"
        }
      },
      {
        path: 'sector',
        name: 'registration3',
        component: Registration3,
        title: 'Company Registration',
        meta: {
          currentProgress: 40,
          label: "3. Your Sector"
        }
      },
      {
        path: 'size',
        name: 'registration4',
        component: Registration4,
        title: 'Company Registration',
        meta: {
          currentProgress: 60,
          label: "4. Company Size"
        }
      },
      {
        path: 'customize',
        name: 'registration5',
        component: Registration5,
        title: 'Company Registration',
        meta: {
          currentProgress: 80,
          label: "5. Basic Details"
        }
      },
      {
        path: 'plan',
        name: 'registration6',
        component: Registration6,
        title: 'Company Registration',
        meta: {
          currentProgress: 100,
          label: "6. Basic Details"
        }
      },
      {
        path: 'building',
        name: 'registrationBuilding',
        component: RegistrationBuilding,
        title: 'Building your account'
      },
      {
        path: 'done',
        name: 'registrationBuildingComplete',
        component: RegistrationBuildingComplete,
        title: 'Building Complete'
      }
    ]
  }
];
